import React from 'react';
import Axios from 'axios';
import ShopProfile from './shopProfile';

export default class AddBasket extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null
        };
    }

    componentWillMount(productID, productName, piece, size) {
        if (size === null) {
            //alert('MESSI');
            window.popUpMessi(productName);
        } else {
            //meghívni egy javascript -et, ami a MESSI ablakot hívja
            //alert('basketJS');
            window.cartSize(productID, productName, piece);
        }
    }

    addBasketItem(productID, productName, piece, size) {
        if (size === null) {
            var url = ShopProfile.getURL() + '/index/post.php';
            var data = new URLSearchParams({
                termekID: productID,
                meret: size,
                db: piece,
                kosar: 'be',
                reverse: false
            });
            Axios.post(url, data)
                .then(res => {
                    //egyenlőre meghívom a MESSI popUP js-t.
                    //console.log(res);
                    this.componentWillMount(productID, productName, piece, size);
                })
        } else {
            //egyenlőre meghivom a régi méret választót
            //main.cartQ(productID, termek, mennyiseg);
            //alert('basketJS');
            this.componentWillMount(productID, productName, piece, size);
        }
    }
}